import { useState } from "react"
import { Button, Collapse, Stack, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { LegislationLibraryFolderChangeRow } from "./legislation-library-folder-change-row"

export function LegislationLibraryManageLocationSummary() {
    const { addedCount, removedCount, addedNodes, removedNodes, onToggle, getPath, isLoading } = useBoundContext()
    const [showChanges, setShowChanges] = useState(false)
    const hasChanges = addedCount + removedCount > 0

    return (
        <Stack spacing={1.5}>
            <If truthy={!isLoading && hasChanges}>
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        size="small"
                        onClick={() => setShowChanges((current) => !current)}
                        data-cy="review-changes-toggle"
                    >
                        {showChanges ? "Hide" : "Review"} changes
                    </Button>
                </Stack>
            </If>
            <Collapse in={showChanges && hasChanges}>
                <Stack spacing={1.5} sx={{ maxHeight: 160, overflowY: "auto" }} data-cy="reference-changes">
                    <If truthy={addedCount > 0}>
                        <Stack spacing={0.5} data-cy="reference-changes-adding">
                            <Typography variant="caption" color="text.secondary">
                                Adding to
                            </Typography>
                            <Bound kind="add" onToggle={onToggle} getPath={getPath}>
                                <Repeat
                                    list={addedNodes}
                                    keyFn={keyForNode}
                                    item={<LegislationLibraryFolderChangeRow />}
                                />
                            </Bound>
                        </Stack>
                    </If>
                    <If truthy={removedCount > 0}>
                        <Stack spacing={0.5} data-cy="reference-changes-removing">
                            <Typography variant="caption" color="text.secondary">
                                Removing from
                            </Typography>
                            <Bound kind="remove" onToggle={onToggle} getPath={getPath}>
                                <Repeat
                                    list={removedNodes}
                                    keyFn={keyForNode}
                                    item={<LegislationLibraryFolderChangeRow />}
                                />
                            </Bound>
                        </Stack>
                    </If>
                </Stack>
            </Collapse>
        </Stack>
    )
}

function keyForNode(node) {
    return node.id
}
